export const ADD_TO_LIST_MODULE_ID = 'lists-add-to-list-module';
export const ADD_TO_LIST_MODULE = () => import('@capital-access/lists/actions').then(m => m.AddToListModule);
